<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]="false"><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <h1>{{ 'turbo.core.JsonDialog.txtHeadline' | translate : 'Edit json' }}</h1>
    <div>
      <mat-form-field appearance="outline" style="width: 100%; min-width: 300px;">
        <textarea matInput required [(ngModel)]="json" matTextareaAutosize matAutosizeMinRows="9" matAutosizeMaxRows="9" [required] style="font-family: 'Courier New';"></textarea>
      </mat-form-field>
    </div> 
     </mat-dialog-content>
<mat-dialog-actions>
  <div style="text-align: center;">
    <button mat-button style="margin: 2px;" color="primary" (click)="validate()">{{ 'turbo.core.JsonDialog.cmdSend' | translate : 'Save' }}</button>
    <button mat-button style="margin: 2px;" [mat-dialog-close]="false">{{ 'turbo.core.JsonDialog.cmdCancel' | translate : 'Cancel' }}</button>
  </div>
</mat-dialog-actions>
